module.exports = __webpack_public_path__ + "img/xpansiongrafting.645f4238.jpg";